// src/services/admin/admin-orderService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const adminOrderApi = axios.create({
  baseURL: `${API_URL}/api/v1/admin/orders`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

adminOrderApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminOrderService = {
  async getOrders(params = {}) {
    const res = await adminOrderApi.get('/', { params });
    return res.data;
  },

  async getStats() {
    const res = await adminOrderApi.get('/stats');
    return res.data;
  },

  async getOrderById(id) {
    const res = await adminOrderApi.get(`/${id}`);
    return res.data;
  },

  async updateOrderStatus(id, payload) {
    const res = await adminOrderApi.patch(`/${id}/status`, payload);
    return res.data;
  },

  async deleteOrder(id) {
    const res = await adminOrderApi.delete(`/${id}`);
    return res.data;
  }
};

export default adminOrderService;